import { BaseForm } from '~/base/BaseForm';

export enum AttachedImagesDeletionFormField {
  imagesToDelete = 'imagesToDelete',
}

export class AttachedImagesDeletionForm extends BaseForm {
  imagesToDelete: Record<string, boolean> = {};

  constructor(props?: unknown) {
    super(props);
    this.load(props);
  }
}
